import { EVENT_BUNDLE_BUILDER } from '~~/constants/googleTagManager';
export const buildBundleBuilderClickItemTags = ({ sku }: { sku: string }) => ({
  event: EVENT_BUNDLE_BUILDER.ITEM_CLICK,
  product_id: sku,
});
